import React from 'react';

const Home = () => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
      <div style={{ background: 'white', padding: 20, borderRadius: 10 }}>📋 Total Questions: 120</div>
      <div style={{ background: 'white', padding: 20, borderRadius: 10 }}>👥 Total Users: 35</div>
      <div style={{ background: 'white', padding: 20, borderRadius: 10 }}>📝 Papers Created: 8</div>
    </div>
  );
};

export default Home;
